module.exports = __webpack_public_path__ + "media/images/error_regist-64ecf0e75eb9a901c731a674440b3cef.png";